import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: yangfan
 * @Date: 2022-01-21 17:11:15
 * @LastEditTime: 2022-01-21 17:11:15
 * @LastEditors: yangfan
 * @Description: 被保人列表
 */
import React, { useEffect, useState } from 'react';
import { Button, Popup, Modal } from 'zarm';
import { isArray } from 'lodash';
import classnames from 'classnames';
import { getState, useStore, getFormValue, setFormValue } from '@/store';
import { queryNoticeQuestionListDetail } from '@/services'; // import { infoText as InsuredNotice } from '@/components/InsuredNotice';

import { getQueryParam, isPreviewMode, isNotEmptyArray } from '@/utils';
import InsuredTrail from '../InsuredTrail';
import InsuredNotice from './InsuredNotice';
import Iconfont from '../Iconfont';
import './index.less'; // 获取枚举中文

const curriedGetEnumName = children => (code, value) => {
  var _dataSource$find;

  if (!(isArray(children) && children.length)) {
    return '';
  }

  const {
    attrs: {
      dataSource
    } = {}
  } = children.find(item => item.code === code) || {};

  if (!(isArray(dataSource) && dataSource.length)) {
    return '';
  }

  return (_dataSource$find = dataSource.find(item => String(item.value) === String(value))) === null || _dataSource$find === void 0 ? void 0 : _dataSource$find.label;
};

const InsuredItem = (props = {}) => {
  const {
    attrs,
    insuredIndex,
    children,
    Render,
    info,
    form,
    config,
    onDeleteItem,
    onSaveItem
  } = props;
  const {
    goodsId
  } = getQueryParam() || {};
  const [popupMode, setPopupMode] = useState('close');
  const [originData, setOriginData] = useState({}); // const relationFormKey = getStatePath(config[0].formKey, 'holderRelation');

  const relationValue = useStore(`formValues.insured[${insuredIndex}].holderRelation`);
  const insureInfo = getFormValue(`insured[${insuredIndex}]`) || {};
  const [noticeDetail, setNoticeDetail] = useState({});
  const [noticeVisible, setNoticeVisible] = useState(false);
  const [selectClauseName, setSelectClauseName] = useState(''); // 计划列表

  const planList = getState('goodsDetail.planList');
  const getEnumName = curriedGetEnumName(children);
  const isPreview = isPreviewMode();
  useEffect(() => {
    if (relationValue === 'self') {
      const insured = getFormValue(`insured[${insuredIndex}]`);
      const holder = getFormValue('holder');

      const newInsure = _objectSpread(_objectSpread(_objectSpread({}, insured), holder), {}, {
        holderRelation: relationValue
      });

      setFormValue(`insured[${insuredIndex}]`, newInsure);
    }
  }, [relationValue]);
  useEffect(() => {
    setPopupMode(insureInfo.mode);

    if (insureInfo.mode !== 'close') {
      const insuredData = getFormValue(`insured[${insuredIndex}]`); // 取消保存时恢复原数据

      if (insuredData.status === 'finish') {
        setOriginData(JSON.parse(JSON.stringify(insuredData)));
      }
    }
  }, [insureInfo.mode]);

  const setItemInfo = (key, value) => {
    setFormValue(`insured[${insuredIndex}].${key}`, value);
  }; // 修改被保人项目编辑状态


  const onChangeInsureModeStatus = (status = 'close') => {
    // setInsureInfo({ ...insureInfo, mode: status });
    setItemInfo('mode', status);
    setPopupMode(status);
  }; // 删除被保人信息


  const onDeleteInsuredItem = (isConfirm = true) => {
    !isConfirm && onChangeInsureModeStatus();
    onDeleteItem(insureInfo.customId, isConfirm);
  }; // 取消保存


  const onCancelEdit = () => {
    Modal.confirm({
      title: '操作确认',
      content: '编辑的内容还未保存，是否关闭？',
      onOk: () => {
        if (insureInfo.mode === 'add') {
          onDeleteInsuredItem(false);
        } else {
          setFormValue(`insured[${insuredIndex}]`, originData);
          onChangeInsureModeStatus();
        }
      }
    });
  };

  const handleSuccess = () => {
    setItemInfo('status', 'finish');
    setItemInfo('mode', 'close');
    setItemInfo('customId', insureInfo.customId);
    onSaveItem();
    onChangeInsureModeStatus();
    setNoticeVisible(false);
  }; // 获取可选条款中选中的条款ID


  const getSelectedClauseList = () => {
    const {
      planId,
      insurancePlanTrialCollect
    } = insureInfo || {};
    const {
      product
    } = insurancePlanTrialCollect || {}; // 当前计划

    const {
      planConfigPackageList
    } = planList.find(planItem => planItem.id === planId) || {};

    if (!isNotEmptyArray(planConfigPackageList) || !product) {
      return [];
    } // 选中的条款


    const selectedProductCodeList = Object.keys(product) ? Object.keys(product).reduce((result, key) => {
      if (product[key] === 'Y') {
        result.push(key.slice(1));
      }

      return result;
    }, []) : []; // 没有选择可选条款

    if (!selectedProductCodeList.length) {
      return [];
    }

    return planConfigPackageList.reduce((res, {
      planConfigProductList
    } = {}) => {
      if (isNotEmptyArray(planConfigProductList)) {
        // 可选条款中，选中的产品包 ID
        planConfigProductList.forEach(({
          productCode,
          productName,
          id,
          isOptional
        } = {}) => {
          if (selectedProductCodeList.includes(productCode) && isOptional === 'Y') {
            res.push({
              id,
              productName
            });
          }
        });
      }

      return res;
    }, []);
  };

  const filterNotice = (arr, idList) => {
    if (!isNotEmptyArray(arr)) {
      return null;
    }

    const planNoticeList = arr.filter(item => item.noticeLevel === 'PLAN');
    const clauseNoticeList = arr.filter(item => item.noticeLevel === 'CLAUSE'); // 计划层级不为空

    if (isNotEmptyArray(planNoticeList)) {
      return planNoticeList[0];
    } // 条款层告知


    if (isNotEmptyArray(clauseNoticeList)) {
      const result = clauseNoticeList.filter(item => idList.includes(item.clauseId));
      return result.length ? result[0] : null;
    }

    return null;
  };

  const getValidateNames = () => {
    return form.getFieldsName(({
      name
    }) => {
      if (Array.isArray(name) && name.length) {
        // 是否是当前投保人关联的因子
        return name.some(key => key.includes(`insured[${insuredIndex}]`));
      }

      return false;
    });
  }; // 重置可选条款为不投保


  const resetOptionalClause = () => {
    const {
      insurancePlanTrialCollect
    } = insureInfo || {};
    const {
      product
    } = insurancePlanTrialCollect || {};
    const keys = Object.keys(product);
    const result = keys.reduce((res, key) => {
      res[key] = 'N';
      return res;
    }, {});
    setItemInfo('insurancePlanTrialCollect.product', result);
  }; // 告知部分同意


  const handleError = () => {
    setNoticeVisible(false);
    const modal = Modal.alert({
      className: 'test',
      title: '提示',
      content: `根据您的健康告知信息，不支持投保{${selectClauseName}}`,
      cancelText: '确认',
      onCancel: () => {
        modal.hide();
        resetOptionalClause();
      }
    });
  }; // 获取计划名称


  const getPlanName = () => {
    if (isNotEmptyArray(planList)) {
      var _planList$find;

      return (_planList$find = planList.find(item => item.id === insureInfo.planId)) === null || _planList$find === void 0 ? void 0 : _planList$find.name;
    }

    return '';
  }; // 保存被保人


  const onSaveInsuredItem = async () => {
    // 表单验证通过
    try {
      const names = getValidateNames();
      await form.validateFields(names); // 选择的可选条款ID

      const selectClauseList = getSelectedClauseList();

      if (!isNotEmptyArray(selectClauseList)) {
        return handleSuccess();
      } // 选中的条款名称


      setSelectClauseName(selectClauseList.map(item => item.productName).join(','));

      try {
        const {
          result
        } = await queryNoticeQuestionListDetail({
          goodsId,
          planId: insureInfo.planId,
          noticeTypeList: ['insureNotice', 'healthNotice']
        });
        const noticeData = filterNotice(result, selectClauseList.map(item => item.id));

        if (!noticeData) {
          return handleSuccess();
        }

        setNoticeDetail(noticeData);
        setNoticeVisible(true);
      } catch (err) {// 获取告知接口报错
      }
    } catch (error) {
      console.log(error);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `insrued-item ${popupMode === 'add' ? 'insured-item-hidden' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "left",
    onClick: onDeleteInsuredItem
  }, /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "delete"
  })), /*#__PURE__*/React.createElement("div", {
    className: "right",
    onClick: () => onChangeInsureModeStatus('edit')
  }, /*#__PURE__*/React.createElement("div", {
    className: "content",
    key: insureInfo.certNo
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("span", null, insureInfo.name), /*#__PURE__*/React.createElement("span", {
    className: `relation-tag ${insureInfo.holderRelation === 'self' ? 'owner-tag' : ''}`
  }, getEnumName('holderRelation', insureInfo.holderRelation)), /*#__PURE__*/React.createElement("span", null, getPlanName())), /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("span", null, getEnumName('certType', insureInfo.certType), "\xA0\xA0", insureInfo.certNo))), /*#__PURE__*/React.createElement("div", {
    className: "detail-icon"
  }, /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "right"
  })))), /*#__PURE__*/React.createElement(Popup, {
    visible: true,
    className: classnames({
      'insured-info-form': true,
      'popup-hidden': insureInfo.mode === 'close',
      'insred-popup-preview': isPreview
    }),
    direction: "bottom",
    onMaskClick: onCancelEdit // afterOpen={() => console.log('打开')}
    // afterClose={() => console.log('关闭')}
    ,
    destroy: false,
    mountContainer: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-box"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "pop-box-title title"
  }, "\u88AB\u4FDD\u4EBA\u4FE1\u606F"), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(Render, {
    components: children
  })), /*#__PURE__*/React.createElement("div", {
    className: "operate"
  }, /*#__PURE__*/React.createElement(InsuredTrail, {
    form: form,
    insuredIndex: insuredIndex
  }), /*#__PURE__*/React.createElement(Button, {
    className: "btn first-btn",
    block: true,
    onClick: onCancelEdit
  }, "\u53D6\u6D88"), /*#__PURE__*/React.createElement(Button, {
    className: "btn",
    block: true,
    theme: "primary",
    onClick: onSaveInsuredItem
  }, "\u4FDD\u5B58")))), /*#__PURE__*/React.createElement(Popup, {
    visible: noticeVisible,
    direction: "bottom",
    className: "insured-info-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "popup-box notice-detail-popup-box"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title pop-box-title"
  }, "\u5065\u5EB7\u544A\u77E5"), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(InsuredNotice, {
    notice: noticeDetail
  })), /*#__PURE__*/React.createElement("div", {
    className: "operate"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "btn first-btn",
    block: true,
    onClick: handleError
  }, "\u90E8\u5206\u4E3A\u662F"), /*#__PURE__*/React.createElement(Button, {
    className: "btn",
    block: true,
    theme: "primary",
    onClick: handleSuccess
  }, "\u4EE5\u4E0A\u5168\u5426")))));
};

export default InsuredItem;